import { format } from "date-fns";

const DATE_FORMAT = 'MM/dd';

export const formatChartDate = (dateString: string): string => {
  const itemDate = new Date(dateString);
  return format(itemDate, DATE_FORMAT).toLowerCase();
};

